import { IClassname } from '@/lib/shared/model/classname';

export const Dishwasher = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.5012 13.9923V4.49919C27.5012 3.08764 26.357 1.94336 24.9454 1.94336H4.4987C3.08716 1.94336 1.94287 3.08764 1.94287 4.49919V27.5017C1.94287 28.9133 3.08716 30.0575 4.4987 30.0575H16.1008"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.2778 23.6679C17.2778 25.3625 17.951 26.9877 19.1493 28.186C20.3476 29.3843 21.9728 30.0575 23.6674 30.0575C25.362 30.0575 26.9873 29.3843 28.1855 28.186C29.3838 26.9877 30.057 25.3625 30.057 23.6679C30.057 21.9733 29.3838 20.3481 28.1855 19.1498C26.9873 17.9515 25.362 17.2783 23.6674 17.2783C21.9728 17.2783 20.3476 17.9515 19.1493 19.1498C17.951 20.3481 17.2778 21.9733 17.2778 23.6679Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.2232 23.6672C26.2232 25.0787 25.079 26.223 23.6674 26.223C22.2558 26.223 21.1116 25.0787 21.1116 23.6672C21.1116 22.2556 22.2558 21.1113 23.6674 21.1113"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.94287 9.61035H27.5012"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1663 13.4443H17.2779"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.41567 6.09599C6.23923 6.09599 6.09619 5.95295 6.09619 5.77651C6.09619 5.60006 6.23923 5.45703 6.41567 5.45703"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.41553 6.09599C6.59197 6.09599 6.73501 5.95295 6.73501 5.77651C6.73501 5.60006 6.59197 5.45703 6.41553 5.45703"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5272 6.09599C11.3508 6.09599 11.2078 5.95295 11.2078 5.77651C11.2078 5.60006 11.3508 5.45703 11.5272 5.45703"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5273 6.09599C11.7038 6.09599 11.8468 5.95295 11.8468 5.77651C11.8468 5.60006 11.7038 5.45703 11.5273 5.45703"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
